/**
 * Featured collection: keep available products when possible, ordered by
 * best-selling via the collection ajax view.
 */
(function () {
  var VIEW = 'tv-featured';
  var SORT = 'best-selling';

  function currentIds(list) {
    return Array.prototype.map.call(list.querySelectorAll(':scope > li[data-product-id]'), function (item) {
      return item.getAttribute('data-product-id');
    }).join(',');
  }

  function refreshCarousel(list) {
    var carousel = list.closest('carousel-slider');
    if (!carousel || !carousel.parentNode) return;

    var clone = carousel.cloneNode(true);
    clone.removeAttribute('loaded');
    clone.setAttribute('inactive', '');
    carousel.parentNode.replaceChild(clone, carousel);
  }

  function applyItems(list, sourceItems, limit, isCarousel) {
    var slice = Array.prototype.slice.call(sourceItems, 0, limit);
    if (!slice.length) return;

    var incomingIds = slice.map(function (item) {
      return item.getAttribute('data-product-id');
    }).join(',');
    if (incomingIds === currentIds(list)) return;

    var hasAvailable = slice.some(function (item) {
      return item.getAttribute('data-available') === 'true';
    });
    if (!hasAvailable) return;

    var fragment = document.createDocumentFragment();
    slice.forEach(function (item, index) {
      var imported = document.importNode(item, true);
      imported.classList.toggle('slider__item', isCarousel);
      imported.setAttribute('data-cc-animate-delay', (index * 0.07).toFixed(2) + 's');
      fragment.appendChild(imported);
    });

    list.replaceChildren(fragment);
    if (isCarousel) refreshCarousel(list);
  }

  function loadList(list) {
    if (list.getAttribute('data-tv-featured-loaded') === 'true') return;

    var collectionUrl = list.getAttribute('data-collection-url');
    var limit = parseInt(list.getAttribute('data-products-to-show'), 10) || 8;
    var isCarousel = list.getAttribute('data-carousel') === 'true';
    var defaultSort = list.getAttribute('data-default-sort');

    if (!collectionUrl) return;
    if (defaultSort === SORT) {
      list.setAttribute('data-tv-featured-loaded', 'true');
      return;
    }

    var url;
    try {
      url = new URL(collectionUrl, window.location.origin);
    } catch (err) {
      return;
    }

    list.setAttribute('data-tv-featured-loaded', 'true');

    url.searchParams.set('view', VIEW);
    url.searchParams.set('sort_by', SORT);

    fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceItems = doc.querySelectorAll('#tv-featured-source > li[data-product-id]');
        applyItems(list, sourceItems, limit, isCarousel);
      })
      .catch(function () {
        list.removeAttribute('data-tv-featured-loaded');
      });
  }

  function init() {
    document.querySelectorAll('[data-tv-featured-products]').forEach(loadList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
